import * as yup from 'yup';
import { DataTableHtmlFormatter } from '../../../../Component/Model/helpers';

const descriptionMaxLength: number = 1000;

export const VaMethodologySchema = yup.object({
    requirementsDescription: yup.string()
        .max(descriptionMaxLength, "Description is too long")
        .transform((value, originalValue) => { return DataTableHtmlFormatter(originalValue, ' ') })
        .required('Description is required')
        .nullable()
})
